import {Component, Input, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {DcpLinkModel} from '@app/model/dcp-link-model';

@Component({
  selector: 'dcp-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SocialMediaComponent {

  @Input() links: Array<Observable<DcpLinkModel>>;
}
